import Page from '../page';



export default class NewsManager extends Page {
	constructor() {
		super();
	}
	init() {







	}
	scroll() {

	}
	resize() {
		window.addEventListener('resize', function (e) {

		})
	}
}